import {
  Button,
  Checkbox,
  FormControlLabel,
  Popover,
  Stack,
  Typography,
} from '@mui/material';
import { useEffect, useRef, useState } from 'react';

import { getDayOfMonthDisplay } from '../frequency';

export const DayOfMonthSelector = ({
  days,
  onChange,
}: {
  days: string[];
  onChange: (days: string[]) => void;
}) => {
  const anchorRef = useRef<HTMLButtonElement>(null);
  const [popoverOpen, setPopoverOpen] = useState(false);

  return (
    <>
      <Button
        sx={{
          padding: '5px 12px',
        }}
        ref={anchorRef}
        onClick={() => setPopoverOpen(true)}
        data-testid='create-backup-policy-day-of-month-select'
        disableFocusRipple
      >
        <Typography fontWeight={600}>
          {days.map((x) => getDayOfMonthDisplay(x)).join(', ')}
        </Typography>

        <i className='material-symbols-arrow-drop-down-rounded text-[22px] ml-[4px]' />
      </Button>
      <DayOfMonthSelectorPopover
        anchorRef={anchorRef}
        days={days}
        onChange={(value) => {
          setPopoverOpen(false);
          onChange(value);
        }}
        popoverOpen={popoverOpen}
      />
    </>
  );
};

const DayOfMonthSelectorPopover = ({
  days,
  onChange,
  anchorRef,
  popoverOpen,
}: {
  popoverOpen: boolean;
  days: string[];
  onChange: (days: string[]) => void;
  anchorRef: React.RefObject<HTMLButtonElement | null>;
}) => {
  const [value, setValue] = useState(days);

  useEffect(() => {
    setValue(days);
  }, [days]);

  return (
    <Popover
      disablePortal
      open={popoverOpen}
      anchorEl={anchorRef.current}
      onClose={() =>
        onChange(
          value.length
            ? value.sort((a, b) => monthDays.indexOf(a) - monthDays.indexOf(b))
            : ['1']
        )
      }
    >
      <Stack
        className='p-[24px] w-[308px] h-[480px]'
        gap='24px'
        overflow='auto'
      >
        <Typography variant='subtitle1'>
          Select at least one day of the month for backups.
        </Typography>
        {monthDays.map((key) => (
          <FormControlLabel
            key={key}
            control={
              <Checkbox
                checked={value.includes(key)}
                onChange={(event, value) =>
                  setValue((state) =>
                    value ? [...state, key] : state.filter((x) => x !== key)
                  )
                }
              />
            }
            label={
              <Typography fontSize={'13px'} className='ml-[12px]'>
                {getDayOfMonthDisplay(key)}
              </Typography>
            }
          />
        ))}
      </Stack>
    </Popover>
  );
};

const monthDays: string[] = [
  ...Array.from({ length: 28 }, (_, i) => `${i + 1}`),
  'L',
];
